import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2.76 8.55L13.5 9.5l-1.74 1.05c-.33.2-.76-.04-.76-.43V4h5v6.12c0 .39-.42.63-.76.43zM7.6 17.2l1.38-1.83c.2-.27.6-.27.8 0L11 17l2.23-2.97c.2-.27.6-.27.8 0l2.38 3.17c.25.33.01.8-.4.8H8c-.41 0-.65-.47-.4-.8z"
}), 'PhotoAlbumRounded');